import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { BalanceCard } from 'console/billing/balance-card';
import { TariffStatus } from 'console/billing/account-tariff/status';
import { CustomIconsPackage } from 'console/billing/package-custom-design';
import { H2000PlusFirmwareCard } from 'entities/billing.h2000-firmware/ui';
import { useShowPaidOptionsWithBalance } from 'console/billing/billing-utils';
import { BuyThermostatForSocket03Card } from 'entities/billing.buy-socket-03-thermostat/ui';
export const BalancePage = () => {
    return (_jsx(ErrorBoundary, { children: _jsx(Box, { display: "flex", flexDirection: "column", alignItems: "center", children: _jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, overflow: "auto", boxSizing: "border-box", mx: 1, children: [_jsx(BalanceCard, { showIosBilling: true }), _jsx(TariffStatus, {}), _jsx(CustomIconsPackage, {}), _jsx(H2000PlusFirmwareCard, {}), _jsx(BuyThermostatForSocket03Card, {})] }) }) }));
};
BalancePage.isShown = (account) => {
    if (account.is_demo) {
        return false;
    }
    const show_paid_options = useShowPaidOptionsWithBalance();
    return show_paid_options;
};
